import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDropdown } from 'core/hooks/useDropdown';

import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import {
  EXTRA_REWARDS_FILTER, SALE_FILTER, EXTRA_REWARDS_FILTER_ID, SALE_FILTER_ID,
} from 'core/modules/ProductSearchResults/utils/keys';
import { triggerPsrApplyFilterGaEvent } from 'core/modules/ProductSearchResults/actions';
import { selectProductSearchResultsConfig } from 'core/modules/ProductSearchResults/selectors';

function FilterPromotionsDesktop({ filterHook }) {
  const dispatch = useDispatch();
  const filterRef = useRef();

  const { filterOptions } = useSelector(selectProductSearchResultsConfig);
  const { promotionsTitle, extraRewardsName, saleName } = filterOptions;

  const { showSubnav, isFocused } = useDropdown(filterRef);
  const { toggleIdInFilter, checkIsIdAddedToFilter } = filterHook;

  const handleOnToggleIdChange = (facetName, id) => {
    toggleIdInFilter(facetName, id);

    const isAddedToFilter = !checkIsIdAddedToFilter(facetName, id);
    dispatch(triggerPsrApplyFilterGaEvent(facetName, isAddedToFilter));
  };

  return (
    <div ref={filterRef} className="mn_filterWrap mn_promotions">
      <button
        className="mn_filterButton"
        onClick={showSubnav}
        aria-expanded={isFocused}
        aria-label={`Opens filter by ${promotionsTitle} list`}
      >
        {promotionsTitle}
      </button>
      { isFocused &&
        <div className="mn_filterDropdown">
          <div className="mn_filterDropdownTitle">{promotionsTitle}</div>
          <ul>
            <li>
              <label>
                <input
                  type="checkbox"
                  onChange={() => handleOnToggleIdChange(EXTRA_REWARDS_FILTER, EXTRA_REWARDS_FILTER_ID)}
                  checked={checkIsIdAddedToFilter(EXTRA_REWARDS_FILTER, EXTRA_REWARDS_FILTER_ID)}
                />
                <span className="mn_name">{extraRewardsName}</span>
              </label>
            </li>
            <li>
              <label>
                <input
                  type="checkbox"
                  onChange={() => handleOnToggleIdChange(SALE_FILTER, SALE_FILTER_ID)}
                  checked={checkIsIdAddedToFilter(SALE_FILTER, SALE_FILTER_ID)}
                />
                <span className="mn_name">{saleName}</span>
              </label>
            </li>
          </ul>
        </div>
      }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><FilterPromotionsDesktop {...props} /></ComponentErrorBoundary>;
